// extracted by mini-css-extract-plugin
export default {"activationRequestList":"LandlordUserManagementForm_activationRequestList__RlilB"};